import { Injectable, Input } from '@angular/core'
import { DiagramsModule } from '../diagrams.module'
import { DiagramData } from '../models/diagram-data'
import { DiagramColorService } from './diagram-color.service'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
// import { AppConfig } from 'projects/jml-lib/src/lib/app-config';
import { AppConfigService } from '../../../app-config/app-config.service'
import { switchMap } from 'rxjs/operators'

@Injectable({
  // providedIn: DiagramsModule
  providedIn: 'root'
})
export class DiagramService {
  constructor(
    private diagramColorService: DiagramColorService,
    private appConfigService: AppConfigService,
    private http: HttpClient
  ) {}

  public getCapacityData(path: string): Observable<DiagramData> {
    return this.appConfigService
      .getUIInfo$()
      .pipe(switchMap((uiInfo) => this.http.get<DiagramData>(uiInfo.baseUrl + path)))
  }
}
